<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import SubmissionHistory from '@/views/Sbr/SubmissionHistory.vue'

setPageTitle(PageMeta.Sbr.Submissions.Title)
definePage({ meta: PageMeta.Sbr.Submissions.Meta })
</script>

<template>
  <SubmissionHistory />
</template>
